import { enAU, enCA, enGB, enUS, frCA } from "date-fns/locale";

export type localeString =
  | "en"
  | "fr"
  | "fr-CA"
  | "en-US"
  | "en-CA"
  | "en-GB"
  | "en-AU";

const dateLocales: Record<string, Locale> = {
  en: enUS,
  "en-US": enUS,
  "en-CA": enCA,
  "en-GB": enGB,
  "en-AU": enAU,
  fr: frCA,
  "fr-CA": frCA,
};

export function useDateFNSLocale(key: localeString): { dateFNSLocale: Locale } {
  const dateFNSLocale = dateLocales[key] ?? enUS;
  return { dateFNSLocale };
}
